"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'template-a[desktop]': {
    'line1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 32,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -161,
        'y': -330,
        'width': 322,
        'height': 32
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 20,
      'letterSpacing': 0,
      'lineHeightPx': 23,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -171,
        'y': -260,
        'width': 342,
        'height': 23
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 64,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -171,
        'y': -237,
        'width': 342,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line4': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 64,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -171,
        'y': -165,
        'width': 342,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line5': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -171,
        'y': -93,
        'width': 342,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#646464'
    }
  },
  'template-a[tablet]': {
    'line1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 21,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1102,
        'y': -305,
        'width': 304,
        'height': 24
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 18,
      'letterSpacing': 0,
      'lineHeightPx': 20,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1087,
        'y': -258,
        'width': 334,
        'height': 20
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 56,
      'letterSpacing': 0,
      'lineHeightPx': 64,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1087,
        'y': -238,
        'width': 334,
        'height': 64
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line4': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 56,
      'letterSpacing': 0,
      'lineHeightPx': 64,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1087,
        'y': -174,
        'width': 334,
        'height': 64
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line5': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 63,
      'letterSpacing': 0,
      'lineHeightPx': 63,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1087,
        'y': -110,
        'width': 334,
        'height': 63
      },
      'children': [],
      'backgrondColor': '#646464'
    }
  },
  'template-a[mobile]': {
    'line1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 21,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1827,
        'y': -150,
        'width': 297,
        'height': 24
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 18,
      'letterSpacing': 0,
      'lineHeightPx': 20,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1812,
        'y': -103,
        'width': 327,
        'height': 20
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 56,
      'letterSpacing': 0,
      'lineHeightPx': 64,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1812,
        'y': -83,
        'width': 327,
        'height': 64
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line4': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 56,
      'letterSpacing': 0,
      'lineHeightPx': 64,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1812,
        'y': -19,
        'width': 327,
        'height': 64
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line5': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 63,
      'letterSpacing': 0,
      'lineHeightPx': 63,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1812,
        'y': 45,
        'width': 327,
        'height': 63
      },
      'children': [],
      'backgrondColor': '#646464'
    }
  },
  'template-b[desktop]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 138,
        'y': 930,
        'width': 375,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 20,
      'letterSpacing': 0,
      'lineHeightPx': 23,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 138,
        'y': 1020,
        'width': 375,
        'height': 23
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 56,
      'letterSpacing': 0,
      'lineHeightPx': 64,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 138,
        'y': 1043,
        'width': 375,
        'height': 64
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line4': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 40,
      'letterSpacing': 0,
      'lineHeightPx': 48,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 138,
        'y': 1107,
        'width': 375,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line5': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 40,
      'letterSpacing': 0,
      'lineHeightPx': 48,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 138,
        'y': 1155,
        'width': 375,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#290a14'
    }
  },
  'template-b[tablet]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 79,
      'letterSpacing': 0,
      'lineHeightPx': 79,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1302,
        'y': 944,
        'width': 279,
        'height': 79
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 18,
      'letterSpacing': 0,
      'lineHeightPx': 20,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1302,
        'y': 1028,
        'width': 279,
        'height': 20
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 49,
      'letterSpacing': 0,
      'lineHeightPx': 55,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1302,
        'y': 1053,
        'width': 279,
        'height': 55
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line4': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 35,
      'letterSpacing': 0,
      'lineHeightPx': 39,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1302,
        'y': 1113,
        'width': 279,
        'height': 39
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line5': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 35,
      'letterSpacing': 0,
      'lineHeightPx': 39,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1302,
        'y': 1157,
        'width': 279,
        'height': 39
      },
      'children': [],
      'backgrondColor': '#290a14'
    }
  },
  'template-b[mobile]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 79,
      'letterSpacing': 0,
      'lineHeightPx': 79,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1836,
        'y': 1110,
        'width': 303,
        'height': 79
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 18,
      'letterSpacing': 0,
      'lineHeightPx': 20,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1836,
        'y': 1194,
        'width': 303,
        'height': 20
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 49,
      'letterSpacing': 0,
      'lineHeightPx': 55,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1836,
        'y': 1219,
        'width': 303,
        'height': 55
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line4': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 35,
      'letterSpacing': 0,
      'lineHeightPx': 39,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1836,
        'y': 1279,
        'width': 303,
        'height': 39
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line5': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 35,
      'letterSpacing': 0,
      'lineHeightPx': 39,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1836,
        'y': 1323,
        'width': 303,
        'height': 39
      },
      'children': [],
      'backgrondColor': '#290a14'
    }
  },
  'template-c[desktop]': {
    'line1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 20,
      'letterSpacing': 0,
      'lineHeightPx': 28,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -379,
        'y': 2611,
        'width': 262,
        'height': 28
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 56,
      'letterSpacing': 0,
      'lineHeightPx': 64,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -379,
        'y': 2644,
        'width': 262,
        'height': 64
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 18.75,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -379,
        'y': 2713,
        'width': 262,
        'height': 23
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line4': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -87,
        'y': 2611,
        'width': 228,
        'height': 131
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-c[tablet]': {
    'line1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 20,
      'letterSpacing': 0,
      'lineHeightPx': 23.4375,
      'color': {
        'r': 0,
        'g': 0,
        'b': 0,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 900,
        'y': 2528,
        'width': 338,
        'height': 29
      },
      'children': [],
      'backgrondColor': '#000000'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 56,
      'letterSpacing': 0,
      'lineHeightPx': 64,
      'color': {
        'r': 0,
        'g': 0,
        'b': 0,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 900,
        'y': 2562,
        'width': 338,
        'height': 64
      },
      'children': [],
      'backgrondColor': '#000000'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 27,
      'color': {
        'r': 0,
        'g': 0,
        'b': 0,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 901,
        'y': 2631,
        'width': 338,
        'height': 27
      },
      'children': [],
      'backgrondColor': '#000000'
    },
    'line4': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0,
        'g': 0,
        'b': 0,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 900,
        'y': 2678,
        'width': 338,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#000000'
    }
  },
  'template-c[mobile]': {
    'line1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 20,
      'letterSpacing': 0,
      'lineHeightPx': 23.4375,
      'color': {
        'r': 0,
        'g': 0,
        'b': 0,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1812,
        'y': 2519,
        'width': 326.0030517578125,
        'height': 29
      },
      'children': [],
      'backgrondColor': '#000000'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 56,
      'letterSpacing': 0,
      'lineHeightPx': 64,
      'color': {
        'r': 0,
        'g': 0,
        'b': 0,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1812,
        'y': 2553,
        'width': 326.0030517578125,
        'height': 64
      },
      'children': [],
      'backgrondColor': '#000000'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 27,
      'color': {
        'r': 0,
        'g': 0,
        'b': 0,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1812.9969482421875,
        'y': 2622,
        'width': 326.0030517578125,
        'height': 27
      },
      'children': [],
      'backgrondColor': '#000000'
    },
    'line4': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0,
        'g': 0,
        'b': 0,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1812,
        'y': 2669,
        'width': 326.0030517578125,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#000000'
    }
  },
  'template-d[desktop]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 60,
      'letterSpacing': 0,
      'lineHeightPx': 60,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 255,
        'y': 3632,
        'width': 435,
        'height': 60
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 84,
      'letterSpacing': 0,
      'lineHeightPx': 95,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 255,
        'y': 3672,
        'width': 435,
        'height': 95
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 28.125,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 255,
        'y': 3772,
        'width': 435,
        'height': 35
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line4': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 18,
      'letterSpacing': 0,
      'lineHeightPx': 21.09375,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 255,
        'y': 3812,
        'width': 435,
        'height': 26
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line5': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 18,
      'letterSpacing': 0,
      'lineHeightPx': 21.09375,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 255,
        'y': 3843,
        'width': 435,
        'height': 26
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-d[tablet]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 60,
      'letterSpacing': 0,
      'lineHeightPx': 60,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1269,
        'y': 3653,
        'width': 339,
        'height': 60
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 56,
      'letterSpacing': 0,
      'lineHeightPx': 64,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1269,
        'y': 3693,
        'width': 339,
        'height': 64
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 20,
      'letterSpacing': 0,
      'lineHeightPx': 28,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1269,
        'y': 3762,
        'width': 339,
        'height': 28
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line4': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1269,
        'y': 3795,
        'width': 339,
        'height': 24
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line5': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1269,
        'y': 3824,
        'width': 339,
        'height': 24
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-d[mobile]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 60,
      'letterSpacing': 0,
      'lineHeightPx': 60,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1811,
        'y': 3843,
        'width': 327,
        'height': 60
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 56,
      'letterSpacing': 0,
      'lineHeightPx': 64,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1811,
        'y': 3883,
        'width': 327,
        'height': 64
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 20,
      'letterSpacing': 0,
      'lineHeightPx': 28,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1811,
        'y': 3952,
        'width': 327,
        'height': 28
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line4': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1812,
        'y': 3985,
        'width': 327,
        'height': 24
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line5': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1812,
        'y': 4014,
        'width': 327,
        'height': 24
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  }
};
exports.default = _default;